import React from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import { vendorTickets } from '../../data/mockData';
import { TicketStatus } from '../../types';
import { formatDate } from '../../utils/dateHelpers';

export default function VendorTickets() {
  const openCount = vendorTickets.filter(t => t.status === TicketStatus.OPEN).length;
  const inProgressCount = vendorTickets.filter(t => t.status === TicketStatus.IN_PROGRESS).length;
  const resolvedCount = vendorTickets.filter(t => t.status === TicketStatus.RESOLVED || t.status === TicketStatus.CLOSED).length;

  const getTicketStatus = (status: TicketStatus): 'open' | 'in_progress' | 'resolved' => {
    if (status === TicketStatus.OPEN) return 'open';
    if (status === TicketStatus.IN_PROGRESS) return 'in_progress';
    return 'resolved';
  };

  const getPriorityColor = (priority: string) => {
    if (priority === 'URGENT') return 'text-danger font-semibold';
    if (priority === 'HIGH') return 'text-warning font-semibold';
    return 'text-text-secondary';
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Open Tickets" value={openCount} bgColor="bg-orange-50" subtextColor="amber" subtext="Awaiting response" />
        <KPICard title="In Progress" value={inProgressCount} bgColor="bg-blue-50" subtext="Being worked on" />
        <KPICard title="Resolved (30d)" value={resolvedCount} bgColor="bg-green-50" subtextColor="green" subtext="All closed" />
        <KPICard title="Avg Resolution" value="1.8 days" subtext="Zebron Solar SLA: 3 days" subtextColor="green" />
      </div>

      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="Service Tickets" subtitle="Zebron Solar — all plants" />
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2.5 text-text-secondary font-semibold">Ticket ID</th>
              <th className="text-left py-2.5 text-text-secondary font-semibold">Plant</th>
              <th className="text-left py-2.5 text-text-secondary font-semibold">Issue Type</th>
              <th className="text-left py-2.5 text-text-secondary font-semibold">Raised</th>
              <th className="text-left py-2.5 text-text-secondary font-semibold">Assigned</th>
              <th className="text-center py-2.5 text-text-secondary font-semibold">Priority</th>
              <th className="text-right py-2.5 text-text-secondary font-semibold">Resolution</th>
              <th className="text-center py-2.5 text-text-secondary font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {vendorTickets.map(ticket => (
              <tr key={ticket.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                <td className="py-2.5 font-mono text-text-secondary">{ticket.id}</td>
                <td className="py-2.5 font-medium text-accent">{ticket.plantId}</td>
                <td className="py-2.5 text-text-primary">{ticket.issueType}</td>
                <td className="py-2.5 text-text-secondary whitespace-nowrap">{formatDate(ticket.raisedDate)}</td>
                <td className="py-2.5 text-text-secondary">{ticket.assignedTo}</td>
                <td className={`py-2.5 text-center ${getPriorityColor(ticket.priority)}`}>{ticket.priority}</td>
                <td className="py-2.5 text-right text-text-secondary">{ticket.resolutionTime ?? '—'}</td>
                <td className="py-2.5 text-center">
                  <StatusPill status={getTicketStatus(ticket.status)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
